var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPuzzle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 18C22 19.1046 21.1046 20 20 20H8.44444C7.33987 20 6.44444 19.1046 6.44444 18V15.2335C6.09691 15.3598 5.72293 15.4286 5.33333 15.4286C3.49238 15.4286 2 13.8935 2 12C2 10.1065 3.49238 8.57143 5.33333 8.57143C5.72293 8.57143 6.09691 8.64018 6.44444 8.76652V6C6.44444 4.89543 7.33987 4 8.44444 4H11.0786C10.9557 4.35746 10.8889 4.74213 10.8889 5.14286C10.8889 7.0364 12.3813 8.57143 14.2222 8.57143C16.0632 8.57143 17.5556 7.0364 17.5556 5.14286C17.5556 4.74213 17.4887 4.35746 17.3659 4H20C21.1046 4 22 4.89543 22 6V18Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPuzzle);
export default __webpack_public_path__ + "static/media/puzzle.c53b63b588a0bddb987f5ba7a9c533ee.svg";
export { ForwardRef as ReactComponent };